"use client";

import { motion } from "framer-motion";

const PrimaryLoader = ({
  size = "default",
  className = "",
  showText = false,
  text = "Loading...",
  fullScreen = false,
}) => {
  const sizeClasses = {
    small: "h-4 w-4",
    default: "h-8 w-8",
    large: "h-12 w-12",
    xlarge: "h-16 w-16",
    xxlarge: "h-32 w-32",
  };

  const loaderContent = (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
        className={`${sizeClasses[size]} border-2 border-transparent border-t-primary border-r-primary rounded-full shadow-lg shadow-primary/20`}
      />
      {showText && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-primary text-sm mt-3 font-medium"
        >
          {text}
        </motion.p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        {loaderContent}
      </div>
    );
  }

  return loaderContent;
};

export default PrimaryLoader;
